<template>
  <div class="login">
    <div class="row justify-content-md-center" style="margin-top:10px;">
      <div class="col-lg-6 col-12">
        <div class="text-center">
          <b-button v-b-modal.create>Ajouter un pronostic</b-button> | <b-button v-b-modal.discount>Gestion des promotions</b-button>
        </div>        
        <div class="row justify-content-center" style="margin-top:10px;">
          <div class="col-lg-6 col-12">
            <b-table striped dark small :items="stats()"></b-table>
          </div>
        </div>
        <b-modal id="create" size="xl" title="Nouveau pronostic" scrollable 
          header-bg-variant="light"
          header-text-variant="dark"
          body-bg-variant="light"
          body-text-variant="dark"
          footer-bg-variant="light"
          footer-text-variant="dark"
          :ok-title="prognostic.id ? 'Modifier' : 'Ajouter'"
          cancel-title="Annuler"
          @ok="onSubmit"
          @hidden="resetPrognostic"
        >
          <div class="row">
            <div class="col-lg-6 col-12">
              <b-alert variant="danger" show v-if="error">{{ error }}</b-alert>
              <b-form @submit="onSubmit">
                <b-alert variant="danger" show v-if="error">{{ error }}</b-alert>
                <b-form-group id="input-group-title" label="Titre:" label-for="input-title">
                  <b-form-input
                    id="input-title"
                    v-model="prognostic.title"
                    type="text"
                    placeholder="Titre"
                    required
                  ></b-form-input>
                </b-form-group>

                <b-form-group id="input-group-date" label="Date:" label-for="input-date">
                  <b-form-input
                    id="input-date"
                    v-model="dateText"
                    type="date"
                    required
                  ></b-form-input>
                </b-form-group>

                <b-form-group id="input-group-type" label="Type:" label-for="input-type">
                  <b-form-select v-model="prognostic.type" :options="types" required></b-form-select>
                </b-form-group>

                <b-form-group id="input-group-win" label="Résultat:" label-for="input-win">
                  <b-form-select v-model="prognostic.win">
                    <option :value="null">Pas de résultat</option>
                    <option :value="true">Gagnant</option>
                    <option :value="false">Perdant</option>
                  </b-form-select>
                </b-form-group>

                <b-form-group id="input-group-cote" label="Côte:" label-for="input-cote">
                  <b-form-input
                      id="input-cote"
                      v-model="prognostic.cote"
                      type="number"
                      placeholder="Cote"
                      step="0.01"
                      min="0"
                      max="10"
                      required
                    ></b-form-input>
                </b-form-group>

                <b-form-group id="input-group-text" label="Description:" label-for="input-text">
                  <b-form-textarea
                    id="input-text"
                    v-model="prognostic.text"
                    type="text"
                    rows="6"
                    required
                  ></b-form-textarea>
                </b-form-group>

                <b-form-group id="input-group-details" label="Détails:" label-for="input-details">
                  <b-form-textarea
                    id="input-details"
                    v-model="prognostic.details"
                    type="text"
                    rows="3"
                  ></b-form-textarea>
                </b-form-group>
              </b-form>
            </div>
            <div class="col-lg-6 col-12">
              <Prognostic v-bind:prognostic="prognostic"/>
            </div>
          </div>
        </b-modal>
        <b-modal id="discount" size="xl" title="Promotions" scrollable 
          header-bg-variant="light"
          header-text-variant="dark"
          body-bg-variant="light"
          body-text-variant="dark"
          footer-bg-variant="light"
          footer-text-variant="dark"
          ok-title="OK"
          cancel-title="Annuler"
          @ok="submitDiscount"
        >
          <div class="row">
            <div class="col-lg-6 col-12">
              <b-form @submit="submitDiscount">
                <b-form-group id="input-group-title" label="Titre:" label-for="input-title">
                  <b-form-input
                    id="input-title"
                    v-model="discount.title"
                    type="text"
                    placeholder="Titre"
                    required
                  ></b-form-input>
                </b-form-group>

                <b-form-group id="input-group-title" label="Prix:" label-for="input-title">
                  <b-form-input
                    id="input-price"
                    v-model="discount.price"
                    type="number"
                    placeholder="4.99"
                    required
                  ></b-form-input>
                </b-form-group>

                <b-form-group id="input-group-date" label="Date de fin:" label-for="input-date">
                  <b-form-input
                    id="input-date"
                    v-model="discountDateText"
                    type="date"
                    required
                  ></b-form-input>
                </b-form-group>

                <b-form-group id="input-group-text" label="Description:" label-for="input-text">
                  <b-form-input
                    id="input-text"
                    v-model="discount.description"
                    type="text"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-form>
            </div>
            <div class="col-lg-6 col-12">
              <b-card
                :title="discount.title"
                footer-tag="footer"
                img-top
                tag="article"
                class="mb-2"
                bg-variant="dark"
                text-variant="white"
              >
                <b-card-text class="text-center">
                  <p class="card-text">
                    <span class="text-warning" style="font-size: 5em;">{{(discount.price+"").replace('.',',')}}€</span>
                    <span></span><br/>
                    <span>{{discount.description}}</span><br/>
                    <span>Se termine dans X jours</span>
                  </p>
                  
                  <div>
                    <input type="image" class="button" src="/img/btn_buynowCC_LG.gif" border="0" name="submit" alt="Payer avec paypal">
                    <img alt="" border="0" src="/img/pixel.gif" width="1" height="1">
                  </div>
                </b-card-text>
              </b-card>
            </div>
          </div>
        </b-modal>
      </div>
      <div class="col-lg-6 col-12">
        <b-list-group>
          <b-list-group-item v-for="prognostic in prognostics" v-bind:key="prognostic.id" variant="dark">
            <b-dropdown right text="Actions" size="sm" class="float-right">
              <b-dropdown-item v-on:click="setWin(prognostic.id, true)"><icon class="button text-success" name="check"></icon>&nbsp;Gagnant</b-dropdown-item>
              <b-dropdown-item v-on:click="setWin(prognostic.id, false)"><icon class="button text-danger" name="times"></icon>&nbsp;Perdant</b-dropdown-item>
              <b-dropdown-item v-on:click="edit(prognostic)"><icon class="button text-secondary" name="edit"></icon>&nbsp;Modifier</b-dropdown-item>
              <b-dropdown-item v-on:click="deletePrognostic(prognostic.id, prognostic.title)"><icon class="button text-danger" name="trash-alt"></icon>&nbsp;Supprimer</b-dropdown-item>
            </b-dropdown>
            {{ moment(prognostic.date).format('DD-MM-YYYY') }} - {{ prognostic.title }}<br/>
            <small v-html="prognostic.text.split('\n')[0]"></small>
            <div>
              <b-badge variant="secondary" style="margin-right: 2px;" v-if="prognostic.type">{{ prognostic.type.toUpperCase() }}</b-badge>
              <b-badge variant="success" style="margin-right: 2px;" v-if="prognostic.win === true">GAGNANT</b-badge>
              <b-badge variant="danger" style="margin-right: 2px;" v-if="prognostic.win === false">PERDANT</b-badge>
            </div>
          </b-list-group-item>
        </b-list-group>
      </div>      
    </div>
  </div>
</template>

<script>
import Prognostic from '@/components/Prognostic.vue'
import { db } from '@/firebase.js'
import moment from 'moment'
const dataRef = db.collection('prognostics')
const tomorrow = moment().hour() < 15 ? moment().startOf('day') : moment().add(1, 'd').startOf('day')

const newProno = function() {
  return { title: '', date: tomorrow.unix(), type: null, win: null, cote: 0, text: '<b>Equipe_1</b> vs. <b>Equipe_2</b>\n<i>Equipe_1 gagne</i>', details: '' }
}
export default {
  data: () => ({
    prognostics: [],
    dateText: tomorrow.format('YYYY-MM-DD'),
    prognostic: newProno(),
    discount: {},
    discountDateText: tomorrow.format('YYYY-MM-DD'),
    types: [
      { value: null, text: 'Selectionner un type de paris' },
      { value: 'basket', text: 'Basket' },
      { value: 'football', text: 'Football' },
      { value: 'tennis', text: 'Tennis' },
      { value: 'multisports', text: 'Multisports' }
    ],
    error: null
  }),
  methods: {
    onSubmit(evt) {
      evt.preventDefault()
      if(this.prognostic.id) {
        dataRef.doc(this.prognostic.id).update(this.prognostic).then(() => {
          this.$bvModal.hide("create")
          this.prognostic = newProno()
        })
        .catch((error) => alert(error))
      } else {
        dataRef.add(this.prognostic).then(() => {
          this.$bvModal.hide("create")
          this.prognostic = newProno()
        })
        .catch((error) => alert(error))
      }
    },
    resetPrognostic() {
      this.prognostic = newProno()
    },
    deletePrognostic(id, title) {
      if(confirm("Confirmer la suppression de " + title + " ?")) {
        dataRef.doc(id).delete()
      }    
    },
    setWin(id, win) {
      dataRef.doc(id).update({ win: win })
    },
    edit(prognostic) {
      this.prognostic = prognostic
      this.$bvModal.show("create")
    },
    moment: (ts) => moment(ts * 1000),
    stats() {
      let items = []
      let current = null
      this.prognostics.forEach((p) => {
        if(p.win != null) {
          let date = moment.unix(p.date);
          if(current != date.format('MMMM YYYY')) {
            current = date.format('MMMM YYYY')
            items.push({ mois: current, gagnant: 0, perdant: 0 });
          }
          if(p.win) {
            items[items.length-1].gagnant++
          } else {
            items[items.length-1].perdant++
          }
          items[items.length-1].taux = Math.round(100 * items[items.length-1].gagnant / (items[items.length-1].gagnant+items[items.length-1].perdant)) + ' %'
        }
      })
      return items;
    },
    submitDiscount(evt) {
      evt.preventDefault()
      db.collection('settings').doc('discount').update(this.discount).then(() => {
        this.$bvModal.hide("discount")
      })
      .catch((error) => alert(error))
    }
  },
  watch: {
    dateText: function(value) {
      this.prognostic.date = moment(value).unix()
    },
    prognostic: function(value) {
      this.dateText = moment.unix(value.date).format('YYYY-MM-DD')
    },
    discountDateText: function(value) {
      this.discount.end = moment(value).unix()
    },
    discount: function(value) {
      this.discountDateText = moment.unix(value.end).format('YYYY-MM-DD')
    }
  },
  components: {
    Prognostic
  },
  firestore: {
    prognostics: dataRef.orderBy('date', 'desc'),
    discount: db.collection('settings').doc('discount'),
  }
}
</script>

<style>
.button {
  cursor: pointer;
}
</style>